import { render, staticRenderFns } from "./TrialBadgeIcon.vue?vue&type=template&id=308b3943&"
import script from "./TrialBadgeIcon.vue?vue&type=script&lang=ts&"
export * from "./TrialBadgeIcon.vue?vue&type=script&lang=ts&"
import style0 from "./TrialBadgeIcon.vue?vue&type=style&index=0&id=308b3943&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports